import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useRef } from 'react';

const tutorials: { id: string; title: string; description: string; videoUrl?: string }[] = [
  {
    id: 'tutorialFirstSettings',
    title: 'Doplnění profilu, pracovní doba a ceník',
    description:
      'Upravíme pracovní dobu pro chytré termíny, barvu aplikace, bankovní účet pro zálohy, link na rezence od zákazníků, věrnostní program, SMS šablony a jako poslední vytvoříme ceník pro chytré termíny.',
    videoUrl:
      'https://www.youtube.com/watch?v=chOGjaL_TDE&list=PLbnbhM6ivxUNctZUVouxU1DZTAZZt95uR&index=22',
  },
  {
    id: 'tutorialStock',
    title: 'Sklad',
    description:
      'Přidání nové skladové položky, nákup i úprava stávajících položek a zobrazení nákupního seznamu. Ukázaní přehledu spotřeby a záznamů o aktivitě (logy).',
    videoUrl: 'https://www.youtube.com/shorts/nOFy5kzl44A',
  },
  {
    id: 'tutorialCustomers',
    title: 'Klienti',
    description:
      'Ruční přidání zákazníka a vytvoření objednávky, správa návštěvy, zavření návštěvy a záznam spotřeby.',
    videoUrl:
      'https://www.youtube.com/watch?v=s1zbi53g2rU&list=PLbnbhM6ivxUNctZUVouxU1DZTAZZt95uR&index=9',
  },
  {
    id: 'tutorialSmartOnlineReservations',
    title: 'Správa chytrých online rezervací pro zákazníky',
    description:
      'Jak nastavit chtré online rezervace pro stálé zákazníky. Odkaz k přidání na váš web najdete u sebe na profilu v aplikaci.',
    videoUrl: 'https://www.youtube.com/shorts/El2kM_4fS6g',
  },
  {
    id: 'tutorialPricingCalculator',
    title: 'Základní finanční report tržeb',
    description:
      'Základní denní, měsíční a roční report tržeb a nákladů pro lepší přehled o vašem podnikání a finančním zdraví vašeho salonu.',
    videoUrl: 'https://www.youtube.com/shorts/-k6arMn8bf4',
  },
  {
    id: 'tutorialImportAndroid',
    title: 'Automatický import všech kontaktů z telefonu - ANDROID',
    description: 'Jak automaticky importovat všechny kontakty z telefonu.',
    videoUrl:
      'https://www.youtube.com/watch?v=9dw7THXOfmo&list=PLbnbhM6ivxUNctZUVouxU1DZTAZZt95uR&index=4',
  },
  {
    id: 'tutorialImportIOS',
    title: 'Automatický import všech kontaktů z telefonu - IOS',
    description: 'Jak automaticky importovat všechny kontakty z telefonu.',
    videoUrl:
      'https://www.youtube.com/watch?v=RRSmqHml8G8&list=PLbnbhM6ivxUNctZUVouxU1DZTAZZt95uR&index=5',
  },
];

export type Id = 'tutorialStock' | 'tutorialService' | 'tutorialProfile';

export const useTutorials = () => {
  const tutorialsDialogRef = useRef<ImperativeFormDialogRefType>(null);

  return {
    tutorials,
    tutorialsDialogRef,
  };
};
